import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check-circle-o.icon",
  "use": "check-circle-o.icon-usage",
  "viewBox": "0 0 162 162",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 162 162\" id=\"check-circle-o.icon\">\n    <path d=\"M110.5 48h-2.62L71.8 84.08 54.93 67.21h-2.62L39 80.43v2.62l31.49 31.49h2.62l50.6-50.6V61.3L110.52 48z\" fill=\"currentColor\" />\n    <circle cx=\"81\" cy=\"81\" r=\"71\" stroke=\"currentColor\" stroke-width=\"20\" fill=\"none\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol